exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".busy *:not(.submit-warn) {\n  opacity: 0.5;\n  z-index: 9999; }\n\n.overlay {\n  position: relative; }\n\nimg.busySpin {\n  margin-top: 12px;\n  position: absolute;\n  left: 50%;\n  transform: translate(-50%, 0);\n  width: 96px; }\n\ninput {\n  float: right; }\n\nh5 {\n  margin-top: 0; }\n\n.adjusted {\n  background: #565656;\n  color: #fff;\n  border-radius: 2px;\n  text-align: right;\n  display: inline-block;\n  padding-right: 6px;\n  padding-left: 6px;\n  float: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/daily-recon/eod-recon/components/form-simple-eod/form-simple-eod.component.scss
// module id = ../../../../../src/app/views/daily-recon/eod-recon/components/form-simple-eod/form-simple-eod.component.scss
// module chunks = main